import MyCart from "@Components/Pages/MyCart";
import dynamic from "next/dynamic";
const Footer = dynamic(() => import("@Components/Layout/Footer"), {
  ssr: false,
});
export default function MyCartPage() {
  return (
    <>
      <MyCart />
      <Footer />
    </>
  );
}
MyCartPage.displayName = "checkout";
